import { computed, inject, ref } from 'vue'

import type { InjectionKey, Ref } from 'vue'

export const weekStartContextKey: InjectionKey<Ref<number>> = Symbol(
  'weekStartContextKey'
)

/**
 * 获取一周的第一天配置
 * 优先使用 ConfigProvider 的 weekStart 配置，否则使用 fallback 默认值
 * @param fallback - 默认值，1 表示周一
 */
export const useWeekStart = (fallback = 1) => {
  const weekStart = inject(weekStartContextKey, ref(fallback))
  return computed(() => weekStart.value ?? fallback)
}
